import { ApplicationConfig, APP_INITIALIZER, ErrorHandler, provideBrowserGlobalErrorListeners } from '@angular/core';
import { provideRouter } from '@angular/router';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { provideNativeDateAdapter } from '@angular/material/core';
import { HTTP_INTERCEPTORS } from '@angular/common/http';

import { routes } from './app.routes';
import { KeycloakAuthService } from './services/keycloak-auth.service';
import { AuthInterceptor } from './interceptors/auth.interceptor';
import { environment } from '../environments/environment';

export function initializeKeycloak(keycloakAuth: KeycloakAuthService) {
  return () => keycloakAuth.init();
}

class GlobalErrorHandler implements ErrorHandler {
  handleError(error: any): void {
    console.error('Erreur globale capturée:', error);
    if (environment.prod && environment.features.enableErrorTracking) {
      // Intégration avec Sentry, etc.
    }
  }
}

export const appConfig: ApplicationConfig = {
  providers: [
    provideBrowserGlobalErrorListeners(),
    provideHttpClient(),
    // Fournir l'intercepteur manuel (ou utiliser withInterceptors)
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthInterceptor,
      multi: true
    },
    provideRouter(routes),
    provideNativeDateAdapter(),
    {
      provide: APP_INITIALIZER,
      useFactory: initializeKeycloak,
      deps: [KeycloakAuthService],
      multi: true
    },
    {
      provide: ErrorHandler,
      useClass: GlobalErrorHandler
    }
  ]
};